import Grid from "@mui/material/Grid";
import { Container } from "@mui/system";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
// import Swiper and modules styles
import "swiper/css";

export const ShowAvis = () => {
    const avis = [
        {
            textavis: "Six petits enfants, six petits vital'eau. Tres agréable,  très propre. Je recommande !",
            nomavis: "Sylvie AMRAM cliente Vital'eau Verrières-Antony",
        },
        {
            textavis:
                "Mon enfant est très content de ses leçons et moi aussi puisque je l'ai vu progresser; il a pris beaucoup d'assurance dans l'eau alors qu'il y a un an il avait encore peur d'y entrer",
            nomavis: "Gwenaelle HUBIER cliente Vital'eau Verrières-Antony",
        },
        {
            textavis:
                "Je recherchais un cours pour mon fils de cinq ans qui ne savait pas nager et surtout qui avait peur de l’eau. Mon fils a été mis à l’aise et accompagné dans son premier cours. Et miracle, la peur a disparue, il a réussi à réaliser les exercices comme les autres enfants. Je suis plus que ravie de vous avoir contacté. Le problème de peur  est résolu ! Sinon piscine à taille humaine, propre et bien organisée",
            nomavis: "Lilouch Leila cliente Vital'eau Verrières-Antony",
        },
        {
            textavis:
                "Accueil sympathique, matériel très bien. Possibilité de réserver des séances suivant nos besoins. Je pratique depuis plusieurs années et je conseille vivement !",
            nomavis: "Adeline Chaberty cliente Vital'eau Verrières-Antony",
        },
        {
            textavis:
                "Je suis membre depuis presque une dizaine d'années. J'ai commencé l'aquagym sur la recommandation de mon rhumatologue car je souffre d'un mal au dos chronique depuis des années. Grâce aux mouvements adéquats, je me suis fait un 'corset' de muscles et mon mal de dos s'est beaucoup amélioré. C'est un endroit très propre, l'ambiance est très bonne et les profs connaissent leur job. Il y a des cours pour tout âge : les enfants, les jeunes et moins jeunes, carrément senior. Tout le monde devrait trouver 'chaussure à son pied'.",
            nomavis: "Olue cliente Vital'eau Verrières-Antony",
        },
        // Ajoutez ici d'autres images avec leurs textes
    ];

    return (
        <div className="position-relative main-avis">
            <section className="vitaleau-section-avis">
                <Container maxWidth="xl" style={{ zIndex: 1, position: "relative" }}>
                    <Grid container>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <div className="">
                                <h2 data-title="Nos avis clients">Nos avis clients</h2>
                                <p>Ils se sont jetés à l'eau avec nous et ils ont adoré !</p>
                            </div>
                            <div className="vitaleau-section-avis-inner">
                                <Swiper
                                    slidesPerView={3}
                                    spaceBetween={24}
                                    autoplay={{
                                        delay: 2500,
                                        disableOnInteraction: false,
                                    }}
                                    modules={[Autoplay]}
                                    className="mySwiper swiperAvis"
                                    breakpoints={{
                                        0: { slidesPerView: 1, spaceBetween: 16 },
                                        576: { slidesPerView: 2, spaceBetween: 20 },
                                        992: { slidesPerView: 3, spaceBetween: 24 },
                                    }}
                                >
                                    {avis.map((avisswiper, index) => (
                                        <SwiperSlide key={index}>
                                            <div className="contain-swiper-avis">
                                                <p>{avisswiper.textavis}</p>
                                                <span>{avisswiper.nomavis}</span>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </section>
        </div>
    );
};
